/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomQuestionnaireAnswerSetSummary } from './CustomQuestionnaireAnswerSetSummary';
import {
  CustomQuestionnaireAnswerSetSummaryFromJSON,
  CustomQuestionnaireAnswerSetSummaryFromJSONTyped,
  CustomQuestionnaireAnswerSetSummaryToJSON,
} from './CustomQuestionnaireAnswerSetSummary';

/**
 *
 * @export
 * @interface PaginatedCustomQuestionnaireAnswerSetSummaryList
 */
export interface PaginatedCustomQuestionnaireAnswerSetSummaryList {
  /**
   *
   * @type {number}
   * @memberof PaginatedCustomQuestionnaireAnswerSetSummaryList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedCustomQuestionnaireAnswerSetSummaryList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedCustomQuestionnaireAnswerSetSummaryList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<CustomQuestionnaireAnswerSetSummary>}
   * @memberof PaginatedCustomQuestionnaireAnswerSetSummaryList
   */
  results: Array<CustomQuestionnaireAnswerSetSummary>;
}

/**
 * Check if a given object implements the PaginatedCustomQuestionnaireAnswerSetSummaryList interface.
 */
export function instanceOfPaginatedCustomQuestionnaireAnswerSetSummaryList(
  value: object,
): value is PaginatedCustomQuestionnaireAnswerSetSummaryList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedCustomQuestionnaireAnswerSetSummaryListFromJSON(
  json: any,
): PaginatedCustomQuestionnaireAnswerSetSummaryList {
  return PaginatedCustomQuestionnaireAnswerSetSummaryListFromJSONTyped(json, false);
}

export function PaginatedCustomQuestionnaireAnswerSetSummaryListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedCustomQuestionnaireAnswerSetSummaryList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(CustomQuestionnaireAnswerSetSummaryFromJSON),
  };
}

export function PaginatedCustomQuestionnaireAnswerSetSummaryListToJSON(
  value?: PaginatedCustomQuestionnaireAnswerSetSummaryList | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(CustomQuestionnaireAnswerSetSummaryToJSON),
  };
}
